import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';

import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { LoadingPopupComponent } from 'src/app/components/ui/loading-popup/loading-popup.component';
import { ModalService } from 'src/app/services/modal/modal.service';
import { CustomModalComponent } from 'src/app/components/ui/custom-modal/custom-modal.component';
import { ErrorModalComponent } from 'src/app/components/ui/error-modal/error-modal.component';
import { FormsModule } from '@angular/forms';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
    selector: 'app-new-forgot',
    imports: [CommonModule, TranslateModule, FormsModule],
    templateUrl: './new-forgot.component.html',
    styleUrl: './new-forgot.component.scss'
})
export class NewForgotComponent implements OnInit {

  email: string = '';
  token: string | undefined;
  captchaRef: any = null;
  modalLoad!: NgbModalRef;
  errorModal!: NgbModalRef;
  modalOk!: NgbModalRef;

  private router = inject(Router);
  private _auth = inject(AuthService);
  private _modal = inject(ModalService);
  private _translate = inject(TranslateService);

  constructor(private _router: Router, ) {
    this.token = undefined;
  }

  ngOnInit(): void {
    // Configurar reCAPTCHA si está disponible
    this.initializeCaptcha();
  }

  initializeCaptcha(): void {
    // Si hay reCAPTCHA disponible en el window object
    if ((window as any).grecaptcha) {
      this.captchaRef = {
        execute: () => {
          console.log('Ejecutando captcha...');
          this.recover();
        }
      };
    } else {
      // Si no hay reCAPTCHA, crear un mock
      this.captchaRef = {
        execute: () => {
          console.log('No reCAPTCHA configurado, procediendo directamente...');
          this.recover();
        }
      };
    }
  }



  async checkRecaptcha(event: string): Promise<void> {
    this.token = event;
    if(this.token){
      this.recover();
    }
  }

  recover(){
    if (!this.email) {
      console.error('Email es requerido');
      return;
    }

    this.modalLoad = this._modal.open(LoadingPopupComponent);

    this._auth.resetPassword(this.email)
    .then(data => {
      this.modalLoad.close();
      this.modalOk = this._modal.open(CustomModalComponent);
      this.modalOk.componentInstance.title = this._translate.instant('recoverEmail_title');
      this.modalOk.componentInstance.description = this._translate.instant('recoverEmail_sent');

      this.router.navigate(['/login']);
    }, err => {
        this.modalLoad.close();
        this.errorModal = this._modal.open(ErrorModalComponent);
        this.errorModal.componentInstance.description = this._translate.instant("recoverEmail_error");
    });
  }

  navigateToLogin(): void {
    console.log('Navegando a login...');
    this.router.navigate(['/login']);
  }

}
